<template>
  <div class="watch-library-wrapp">
    <template v-if="vodInfo">
      <div class="video-wrapp">
        <player-controller
          v-if="!embedded"
          :options="videoOptions"
          :analytics-allowed="false"
          :event="vodInfo"
        />
        <div v-else v-html="embedded"></div>
      </div>
      <div class="video-description-wrapper">
        <span class="video-title">{{ vodInfo.title }}</span>
        <span v-if="categoryTitle" class="video-category">{{ categoryTitle }}</span>
        <span v-if="host" class="video-host">{{ $t('Host') }}: {{ host }}</span>
        <span v-if="formattedDate" class="video-date">{{ formattedDate }}</span>
        <span class="video-description">{{ vodInfo.description }}</span>
      </div>
    </template>
    <template v-else>
      <div>
        <loader-component/>
      </div>
    </template>
  </div>
</template>

<script>
import {ASSETS_TYPE} from '@/const';
import {mapActions} from 'vuex';
import LoaderComponent from '../../components/LoaderComponent';
import {GET_VOD_ITEM, GET_VOD_CATEGORIES} from '@/store/actionTypes';
import PlayerController from '@/components/video/PlayerController.vue';

export default {
  name: 'WatchLibraryScreen',
  data() {
    return {
      vodInfo: null,
      id: this.$route.params.id,
      categories: null,
    };
  },
  components: {PlayerController, LoaderComponent},
  methods: {
    ...mapActions({
      getVodItem: GET_VOD_ITEM,
      getVodCategories: GET_VOD_CATEGORIES,
    }),
  },
  computed: {
    embedded() {
      return this.vodInfo?.assets.find((item) => item.type === ASSETS_TYPE.embed)?.path;
    },
    videoPath() {
      return this.vodInfo?.assets?.find((asset) => asset.type === ASSETS_TYPE.video)?.path;
    },
    videoOptions() {
      return {
        autostart: true,
        file: this.videoPath,
      };
    },
    categoryTitle() {
      return this.categories?.find(({id}) => {
        return Number(id) === Number(this.vodInfo?.vod_media_category_id);
      })?.title;
    },
    host() {
      return this.vodInfo?.metadata?.host;
    },
    formattedDate() {
      const date = new Date(this.vodInfo?.date);
      const d = date.getDate();
      const m = date.toLocaleDateString(this.$i18n.locale(), {month: 'long'});
      const y = date.getFullYear();
      return `${d} ${m} ${y}`;
    },
  },
  mounted() {
    const params = {
      id: this.id,
    };
    this.getVodItem(params)
        .then(({data}) => {
          this.vodInfo = data;
        })
        .catch((_) => (this.vodInfo = null));
    this.getVodCategories()
        .then(({data}) => this.categories = data)
        .catch((_) => (this.categories = null));
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/css/mixins";
@import "src/assets/css/colors";

.watch-library-wrapp {
  --content-width: 80vw;
  @include media-max(lg) {
    --content-width: calc(100vw - 2rem)
  }

  margin-top: 1.5rem;
}

.video-wrapp {
  max-width: var(--content-width);
  margin: 0 auto;
}

.video-description-wrapper {
  max-width: var(--content-width);
  display: flex;
  flex-direction: column;
  text-align: left;
  margin: 2rem auto;
  color: $text-tertiary-middle;
}

.video-title {
  font-size: 1.5rem;
  color: $text-primary;
}

.video-description {
  margin-top: 1rem;
}
</style>
